export const FeedbackRptConstants ={
    GETALL_REQUEST: 'FEEDBACK_GETALL_REQUEST',
    GETALL_SUCCESS: 'FEEDBACK_GETALL_SUCCESS',
    GETALL_FAILURE: 'FEEDBACK_GETALL_FAILURE',
    

    GETALLEX_REQUEST: 'FEEDBACK_GETALLEX_REQUEST',
    GETALLEX_SUCCESS: 'FEEDBACK_GETALLEX_SUCCESS',
    GETALLEX_FAILURE: 'FEEDBACK_GETALLEX_FAILURE',

    GETEXPORTEX_REQUEST: 'FEEDBACK_GETEXPORTEX_REQUEST',
    GETEXPORTEX_SUCCESS: 'FEEDBACK_GETEXPORTEX_SUCCESS',
    GETEXPORTEX_FAILURE: 'FEEDBACK_GETEXPORTEX_FAILURE',

    GETEXPORT_REQUEST: 'FEEDBACK_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'FEEDBACK_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'FEEDBACK_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}